import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class DealerStore extends LocalModel {
    constructor() {
        super('dealer', {
            namePlural: 'dealers',
            namePluralReal: 'dealers',
            sort: 'name',
            limit: 100,
            api: {
                search: {
                    url: '/api/dealers/',
                    params: {
                        limit: 100,
                        sort: 'name',
                    },
                },
                load: {
                    url: '/api/dealers/',
                    params: {},
                },
                save: {
                    url: '/api/dealers/',
                    params: {},
                },
                delete: {
                    url: '/api/dealers/',
                    params: {},
                },
            },
        });
    }

    @observable newDealer = {};

    @observable dealer = {};

    @observable dealers = [];

    @observable prefixes = [];

    @action
    setPrefixes = (prefixes) => {
        this.prefixes = prefixes;
    }

    loadPrefixes = async () => {
        const response = await util.fetchApi('/api/products/prefixes', { method: 'GET' }, {});
        if (response && response.status === 200) {
            this.setPrefixes(response.data || []);
            // Also update dealers list if included
            if (response.included && response.included.dealers) {
                this.setList(response.included.dealers);
            }
        }
        return response;
    }

    linkDealerToPrefix = async (prefix, dealerId) => {
        const response = await util.fetchApi('/api/products/link-dealer', { method: 'POST' }, {
            prefix,
            dealerId,
        });
        if (response && response.status === 200) {
            // Reload prefixes to get updated state
            await this.loadPrefixes();
        }
        return response;
    }

    @action
    setList = (list) => {
        this.dealers = list;
    }
}

const store = new DealerStore();
export default store;

// Named export for the class itself
export { DealerStore };
